module.exports = __webpack_public_path__ + "img/4.7e491ac9.png";